module.exports = __webpack_public_path__ + "static/media/ss_te.fa838671.png";